import React from 'react';
import { Pluggable } from '@plone/volto/components/manage/Pluggable';

/**
 * BannerNotice component class.
 * @class Header
 * @extends Component
 */
const BannerNotice = () => {
  return (
    <Pluggable name="banner-notice">
      {(pluggables) =>
        pluggables.map((p, i) => (
          <div className="banner-notice" key={i}>
            {p()}
          </div>
        ))
      }
    </Pluggable>
  );
};

export default BannerNotice;
